import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { Calendar, Shield, TrendingUp } from "lucide-react";
import React from "react";

interface AdditionalNetworkKPIsProps {
  data: any;
}

export const AdditionalNetworkKPIs: React.FC<AdditionalNetworkKPIsProps> = ({
  data,
}) => {
  const getRiskLevel = (score: number) => {
    if (score <= 30) return "Low risk";
    if (score <= 60) return "Medium risk";
    return "High risk";
  };

  const getComplianceStatus = (percentage: number) => {
    if (percentage >= 95) return "Within target";
    if (percentage >= 85) return "Above minimum";
    return "Below target";
  };

  const getServiceStatus = (percentage: number) => {
    if (percentage >= 95) return "Above target";
    if (percentage >= 90) return "Within target";
    return "Below target";
  };

  const cards = [
    {
      title: "Avg Remaining Life",
      displayValue: `${data?.overview?.avgRemainingLife?.value} yrs`,
      tooltip:
        "The average estimated time remaining before the assets in this network are expected to require major overhaul or replacement.",
      trendSummary: "Above target",
      icon: <Calendar className="h-6 w-6 text-blue-600" />,
    },
    {
      title: "Inspection Compliance",
      displayValue: `${data?.overview?.inspectionCompliance?.value}`,
      tooltip:
        "The percentage of all scheduled inspections for this network that were completed by their due date in the last period.",
      icon: <TrendingUp className="h-6 w-6 text-green-600" />,
    },
    {
      title: "Overall Risk Score",
      displayValue: `${data?.overview?.overallRiskScore?.value}`,
      tooltip:
        "The overall risk this network poses, based on its criticality assessment. A lower score indicates lower risk.",
      icon: <Shield className="h-6 w-6 text-green-600" />,
    },
    {
      title: "Service Level Achievement",
      displayValue: `${data?.overview?.serviceLevelAchievement?.value}`,
      tooltip:
        "The percentage of time this network has operated within its defined Service Level Agreement (SLA) targets.",
      icon: <TrendingUp className="h-6 w-6 text-green-600" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, idx) => (
        <QuickStatsCard key={idx} {...card} />
      ))}
    </div>
  );
};
